
import Vue from 'vue';

export const VifTypeMap:any = {
    primary: Vue.$trans(`主网卡`),
    extension: Vue.$trans(`辅网卡`)
};
